<template>
    <v-card v-if="performance !== null" class="performance-card mb-12 py-8">
        <v-card-title class="text-h5 d-flex justify-center">Performance Report<br>
        </v-card-title>
        <div style="text-align: center"> {{ performance.beginDate }} to {{ performance.endDate }} </div>
        <highcharts :options="options" :update-args="updateArgs"></highcharts>
    </v-card>
</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
    name: "YearToDateHighCharts",

    props: {
        performance: {
            type: Object,
            default: () => {}
        }
    },

    components: {
      highcharts: Chart
    },

    data() {
        return {
            updateArgs: [true, true, {duration: 1000}],
            options: {
                chart: {
                    defaultSeriesType: 'spline',
                    height: 400,
                    backgroundColor: 'transparent',
                    plotBackgroundColor: 'transparent',
                    animation: false,
                    spacingBottom: 30,
                    spacingTop: 30,
                    spacingLeft: 40,
                    spacingRight: 40
                },
                xAxis: {
                    type: 'datetime',
                    showLastLabel: true,
                    startOnTick: true,
                    tickInterval: 2506000000,
                    labels: {
                        rotation: -45,
                        step: 1,
                        style: {
                            color: '#272727',
                            fontSize: '14px'
                        }
                    },

                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    labels: {
                        format: '{value}.00%',
                        style: {
                            color: '#272727',
                            fontSize: '14px'
                        }
                    },
                    tickInterval: 1,
                },
                series: {},
                title: {
                    text: null
                },
                subtitle: {
                    text: null
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                    },
                    series: {
                        marker: {
                            enabled: false
                        },
                        lineWidth: 2,
                        animation: false,
                    }
                },
                navigator: {
                    enabled: false
                },
                scrollbar: {
                    enabled: false
                },
                rangeSelector: {
                    enabled: false
                },
                exporting: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
            }
        }
    },
    mounted() {
        this.options.series = this.performance.highcharts.series;
    }
}
</script>

<style>

    .performance-card .v-card__title {
        color: #1D5BE5;
    }

</style>
